import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    standalone: false,
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, OnChanges {
    @Output() page = new EventEmitter<any>();
    @Input() limit;
    @Input() stopNextPaginator;
    @Input() offset;
    @Input() limitOptions;
    @Input() totalRecords;
    numItems = new FormControl();
    pagination: any = {};

    constructor() { }

    ngOnChanges() {
        this.asignPaginator();
        this.numItems.setValue(this.limit);
    }

    ngOnInit() {
    }


    asingNumberItems(event) {
        this.pagination.limit = event.value;
        this.pagination.offset = 0;
        this.emitPaginator();
    }

    previousPage() {
        this.pagination.offset = this.pagination.offset > 0 ? (this.pagination.offset - this.limit) : 0;
        this.emitPaginator();
    }

    initPage() {
        this.pagination.offset = 0;
        this.emitPaginator();
    }

    lastPage() {
        let finalOffset = (Math.floor(this.totalRecords / this.limit) === (this.totalRecords / this.limit))
                            ? ((this.totalRecords / this.limit) - 1) * this.pagination.limit
                            : Math.floor(this.totalRecords / this.limit) * this.pagination.limit;
        this.pagination.offset = finalOffset;
        this.emitPaginator();
    }

    nextPage() {
        this.pagination.offset = this.pagination.offset + this.limit;
        this.emitPaginator();
    }

    emitPaginator() {
        this.page.emit(this.pagination);
    }

    asignPaginator() {
        this.pagination.limit = this.limit;
        this.pagination.offset = this.offset;
        this.pagination.limitOptions = this.limitOptions;
    }

    getRangeLabel(offset: any, limit: any): String {
        let firsValue = offset+1;
        let lastValue = ((offset + limit) <= this.totalRecords) ? (offset + limit) : this.totalRecords;
        return "" + firsValue + " - " + lastValue + " de " + this.totalRecords + " registros";
    }
    getPagesLabel(offset: any, limit: any): String {
        let firsValue = (offset/limit)+1;
        let lastValue = Math.ceil(this.totalRecords/limit);
        return "<Pág. " + firsValue + "> de " + lastValue;
    }
    isLastPage(){
        return (this.totalRecords - this.pagination.offset <= this.pagination.limit) ? true : false;
    }

}
